import React, { FC, useState, useEffect, useRef } from "react";
import { Avatar } from "antd";
import Card, { CardHeader, CardBody } from "@components/card";

import "./notes.scss";
//import { TNotesCardProps } from "../constant";
// import moment from "moment";
import { changeDateFormatinDescription, formatDisplayDate } from "@utils/helpers";
import membersService from "@services/members.service";
import { useNavigate } from "react-router-dom";
import { routeMap } from "@utils/constants";

//const READ = true;

const NotesCard: FC<any> = ({ className, width, avatarSize, bookmarkClickHandler, data, onShowMore }: any) => {
  const { recipientName = "", notificationDescription = "", notificationDate = "", recipientID = "" } = data || {};
  const [contentHeight, setContentHeight] = useState(0);
  const content = useRef<HTMLDivElement>(null);
  // const charLength = 80;

  useEffect(() => {
    setTimeout(() => {
      setContentHeight(content.current?.scrollHeight || 0);
    }, 50);
  }, [notificationDescription]);

  const toggleShowMore = () => {
    if (content.current) {
      content.current.scrollTop = 0;
    }
    onShowMore(data.isShowMore ? false : true);
  };

  const getContentView = () => {
    return (
      <>
        <div className={`notificationContent__description ${data.isShowMore ? "more" : "notificationContent__description__less"}`} ref={content}>
          {changeDateFormatinDescription(notificationDescription, false)}
        </div>
        {/* <span className="link showMoreLink clr-blueLink" onClick={showMore}>
          ...more
        </span> */}
        {contentHeight > 40 && (
          <div className="noteContent__showMoreLink" onClick={toggleShowMore}>
            {data.isShowMore ? "less" : "more"}
          </div>
        )}
      </>
    );
  };

  const navigate = useNavigate();

  const goToMemberDetails = () => {
    membersService.membersByIds([recipientID]).subscribe({
      next: (v) => {
        let member = v?.data?.data?.patientList.pop();
        if (member) {
          membersService.setCurrentMember = member;
          membersService.setsingleMember = false;
          navigate(routeMap.memberProfile);
        }
      },
    });
  };

  return (
    <Card className={`${className} notification ${data.isShowMore? 'showMore':'showLess'} `} width={width} id={`drawer_notification_card_${data?.notificationID}`}>
      <CardHeader className="notesCardHeader f14">
        {/* <Avatar className="card-avatar">{recipientName?.charAt(0)}</Avatar> */}
        <span className="clr-blueLink w500" style={{ cursor: "pointer" }} onClick={goToMemberDetails}>
          {recipientName}
        </span>
      </CardHeader>
      <CardBody className="notesCardBody">
        <span className="italic f10 clr-lightGrayColor">{formatDisplayDate(notificationDate, "reminderDateActualFormat", "defaultDateFormatWithTimeWithPipe", true)}</span>
        {getContentView()}
      </CardBody>
    </Card>
  );
};

export default NotesCard;
